// extracted by mini-css-extract-plugin
export var button = "_ji-0";
export var donut = "_ji-1";
export var donutFill = "_ji-3";
export var donutTrack = "_ji-2";